import React, { useEffect, useState } from 'react';
import { LineChart } from 'lucide-react';
import { fetchPublicSettings } from '../../features/settings/api/settings';
import type { SiteSettings } from '../../types';

export function BrandLogo() {
  const [s, setS] = useState<SiteSettings | null>(null);
  useEffect(() => {
    fetchPublicSettings()
      .then((v) => setS(v))
      .catch(() => {});
  }, []);

  return (
    <div className="flex items-center gap-3" data-testid="brand-logo">
      <div className="w-11 h-11 rounded-xl bg-cyan-400/10 border border-cyan-400/30 flex items-center justify-center shadow-[0_0_15px_rgba(0,229,255,0.25)] overflow-hidden shrink-0">
        {s?.logo_url ? (
          <img src={s.logo_url} alt="logo" className="w-full h-full object-contain" data-testid="brand-logo-img" />
        ) : (
          <LineChart className="w-6 h-6 text-cyan-400" strokeWidth={1.5} />
        )}
      </div>
      <div className="min-w-0">
        <p className="text-white text-lg font-medium tracking-tight truncate" title={s?.site_name || 'Cuantrader'}>{s?.site_name || 'Cuantrader'}</p>
        <p className="text-[10px] uppercase tracking-[0.25em] text-cyan-400/80">Community</p>
      </div>
    </div>
  );
}
